import {CustomerMessageState} from '@dms/api/core';

import {Nullish} from 'shared/web';

export function isCustomerMessageDeliveryError(state: CustomerMessageState | Nullish): boolean {
  return state === 'failed';
}
